
export default {
  data() {
    return {
      WIKI_KEY: 'kmwiki',
      isFromWiki: false,
      wikiBanedFuncs: ['gohome']
    }
  },
  created() {
    this.handleFromWiki()
  },
  computed: {
    isWikiBaned() {
      return (func) => this.isFromWiki && this.wikiBanedFuncs.includes(func)
    }
  },
  methods: {
    handleFromWiki() {
      const query = this.$route.query
      query.source === this.WIKI_KEY && (this.isFromWiki = true)
    }
  }
}